import { useMemo } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import { SxStyle } from '../../../types';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Match } from './utils/data';
import Box from '@mui/material/Box';

const styles: SxStyle = {
  container: {
    width: '100%',
    height: 'calc(100vh - 300px)',
  },
  dataGrid: (theme) => ({
    border: 0,
    '& .MuiDataGrid-root .MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-row:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
    },
  }),
};

export default function MatchEvents({ matchDoc }: { matchDoc: Match }) {
  const { strings } = useStringsContext();

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'gameTime',
        headerName: strings.matches.minute,
        width: 160,
        valueGetter: (value, row) => row.minuteWithStoppageTime,
      },
      // { field: 'key', headerName: strings.matches.matchId, width: 400, hide: true },
      {
        field: 'type',
        headerName: strings.matches.type,
        width: 160,
        valueGetter: (value) => (value ? strings.eventType[value] : undefined),
      },
      { field: 'description', headerName: strings.matches.description, flex: 1 },
      { field: 'source', headerName: strings.matches.source, width: 160 },
      { field: 'rating', headerName: strings.matches.rating, width: 160 },
    ],
    [strings]
  );

  return (
    <Box sx={styles.container}>
      <DataGrid
        sx={styles.dataGrid}
        rows={matchDoc.matchEvents || []}
        columns={columns}
        autoPageSize
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        getRowId={(row) => row.key}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: 'gameTime',
                sort: 'desc',
              },
            ],
          },
        }}
      />
    </Box>
  );
}
